import React from "react"
import Tilt from 'react-vanilla-tilt'

import "../utils/css/components/team-card.css"


export default teamCard => (
    <div className="Tilt-inner">

        {/* <div className="bg-image"
                style={
                    teamCard.thumbnail && {
                        backgroundImage: `url(${
                            teamCard.thumbnail
                            })`
                    }
                }
            ></div>
            <div className="card">
                <div className="project-name">{teamCard.name}</div>
                <div className="categories">
                    {teamCard.position}
                </div>
            </div> */}
        <div className="team-card">
            <Tilt className="Tilt team-card-tilt" options={{ scale: 2, max: 25 }} style={{ height: '100%', width: '100%' }} >
                <div className="team-image" style={
                    teamCard.thumbnail && {
                        backgroundImage: `url(${
                            teamCard.thumbnail
                            })`
                    }
                }></div>
            </Tilt>
            <div className="team-content">
                <div className="team-name">
                {teamCard.name}
                </div>
                <div className="team-position">
                {teamCard.position}
                </div>
                <p>
                    {teamCard.description}
                </p>
            </div>
        </div>
    </div>
)
